// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"b5175b73","363":"b5175b73","732":"b5175b73","746":"b5175b73","991":"b5175b73"}[chunkId] + ".chunk.css";
};